import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21b39760"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["for"]
const _hoisted_2 = ["id", "name", "value"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))

import { ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'MySelectFilter',
  props: {
    name: {},
    for: {},
    value: {}
  },
  emits: ["update:modelValue", "blur"],
  setup(__props: any, { emit: __emit }) {

const inputSelectRef = ref<HTMLInputElement | null>(null)

const props = __props

const emit = __emit

const onInputChange = (event: Event) => {
  const target = event.target as HTMLInputElement
  const newValue = target.value
  emit('update:modelValue', newValue, props.name)
}

const onBlur = (event: Event) => {
  const target = event.target as HTMLInputElement
  const value = target.value
  emit('blur', value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", {
    class: "mySelect",
    for: props.name || ''
  }, [
    _createElementVNode("input", {
      ref_key: "inputSelectRef",
      ref: inputSelectRef,
      type: "text",
      placeholder: "Selecione",
      onInput: onInputChange,
      onBlur: onBlur,
      id: props.name,
      name: props.name,
      value: _ctx.value,
      autocomplete: "off"
    }, null, 40, _hoisted_2),
    _hoisted_3,
    _createElementVNode("div", null, [
      _createElementVNode("ul", null, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ])
  ], 8, _hoisted_1))
}
}

})